import React from "react";

import FormattedNumberInput, { TextInputProps } from "../FormattedNumberInput";

const usdFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const usdTo2Places = (n: string | number): string => {
  const num = Number(n);
  return num === 0 ? "$0" : usdFormatter.format(num);
};

export const formValueToDisplayValue = (
  value: string | number,
  suffix: string | undefined,
): string => `${usdTo2Places(value)}${suffix || ""}`;

export const formValueToEditableValue = (value: string | number): string => {
  const num = Number(value);
  if (Number.isNaN(num)) {
    return "";
  }
  return num === 0 ? "0" : num.toFixed(2);
};

export interface DollarInputProps extends TextInputProps {
  suffix?: string;
}

const DollarInput = (props: DollarInputProps) => {
  const { suffix, ...textInputProps } = props;

  return (
    <FormattedNumberInput
      formValueToDisplayValue={value =>
        !Number.isNaN(Number(value)) ? formValueToDisplayValue(value, suffix) : ""
      }
      formValueToEditableValue={formValueToEditableValue}
      editableValueToFormValue={formValueToEditableValue} // nothing different for money
      {...textInputProps}
    />
  );
};

export default DollarInput;
